import { adminAPIService, adminFileDownloadService } from './index'

const route = 'marketplace'

const getOrdersParams = ({
  paymentStatusId,
  orderNumber,
  merchantId,
  fromDate,
  toDate,
  exportCsv,
  exportReportType,
}, page, size) => {
  const params = { page, size }
  if (paymentStatusId) {
    params.payment_status_id = paymentStatusId
  }
  if (orderNumber) {
    params.order_number = orderNumber
  }
  if (merchantId) {
    params.merchant_id = merchantId
  }
  if (fromDate) {
    params.from_date = fromDate
  }
  if (toDate) {
    params.to_date = toDate
  }
  if (exportCsv) {
    params.export_csv = exportCsv
  }
  if (exportReportType) {
    params.export_report_type = exportReportType
  }
  return params
}

export default {
  // Order
  getOrders(filters, page = 1, size = 20) {
    const params = getOrdersParams(filters, page, size)

    return adminAPIService({
      url: `${route}/orders/list`,
      method: 'get',
      params,
    })
  },
  downloadOrders(filters) {
    const params = getOrdersParams(filters)
    return adminFileDownloadService({
      url: `${route}/orders/list`,
      method: 'get',
      headers: {
        'Content-Type': 'text/csv',
      },
      data: {}, // https://github.com/axios/axios/issues/86#issuecomment-139638284
      params,
    })
  },
  approveOrder(orderNumber) {
    return adminAPIService({
      url: `${route}/orders/approve_pending/${orderNumber}`,
      method: 'post',
    })
  },
  // Featured Brands
  getFeaturedBrands(page = 1, size = 50) {
    return adminAPIService({
      url: `${route}/featured_brand`,
      method: 'get',
      params: { page, size },
    })
  },
  getFeaturedBrandDetail(id) {
    return adminAPIService({
      url: `${route}/featured_brand/${id}`,
      method: 'get',
    })
  },
  addFeaturedBrand(brandDetail) {
    const body = `json=${encodeURIComponent(JSON.stringify(brandDetail))}`
    return adminAPIService({
      url: `${route}/featured_brand`,
      method: 'post',
      data: body,
    })
  },
  editFeaturedBrand(brandDetail, id) {
    const body = `json=${encodeURIComponent(JSON.stringify(brandDetail))}`
    return adminAPIService({
      url: `${route}/featured_brand/${id}`,
      method: 'post',
      data: body,
    })
  },
  deleteFeaturedBrand(id) {
    return adminAPIService({
      url: `${route}/featured_brand/${id}`,
      method: 'delete',
    })
  },
  getCountryList() {
    return adminAPIService({
      url: `${route}/countries/list`,
      method: 'get',
    })
  },
  getCurrencyList() {
    return adminAPIService({
      url: `${route}/currencies/list`,
      method: 'get',
    })
  },
  getMerchantList() {
    return adminAPIService({
      url: `${route}/merchants/list`,
      method: 'get',
    })
  },
  getMerchantsInfo(params) {
    /*
      @params: {
        keywords: string    // keyword of store name
        page: number
        size: number
      }
    */
    return adminAPIService({
      url: `${route}/merchants`,
      method: 'get',
      params,
    })
  },
  getMerchantDetail(id) {
    return adminAPIService({
      url: `${route}/merchants/${id}`,
      method: 'get',
    })
  },
  updateMerchantInfo(merchant, store_coupon_image) {
    const formData = new FormData()
    formData.append('json', JSON.stringify(merchant))
    formData.append('store_coupon_image', store_coupon_image)
    // const body = `json=${encodeURIComponent(JSON.stringify(merchant))}`
    return adminAPIService({
      url: `${route}/merchants/${merchant.id}`,
      method: 'post',
      data: formData,
    })
  },
  // refund orders
  getRefundlist(orderNum) {
    return adminAPIService({
      url: `${route}/orders/refunds`,
      method: 'get',
      params: {
        order_number: orderNum,
      },
    })
  },
  getOrderSummary({
    platform,
    start_date,
    end_date,
    merchant_id,
    payment_currency,
    gx_platform,
    order_number,
    country_id,
    }) {
    return adminAPIService({
      url: `${route}/orders/summary`,
      method: 'get',
      params:{
        platform,
        start_date,
        end_date,
        merchant_id,
        payment_currency,
        gx_platform,
        order_number,
        country_id,
      },
    })
  },
  getAllCoupon() {
    return adminAPIService({
      url: '/discounts',
      method: 'get',
    })
  },

  getCouponDetails(id) {
    return adminAPIService({
      url: `/discounts/${id}`,
      method: 'get',
    })
  },

  createCoupon(form) {
    const body = `json=${encodeURIComponent(JSON.stringify(form))}`
    return adminAPIService({
      url: `/discounts`,
      method: 'post',
      data: body,
    })
  },
  addCoupon({form, id}) {
    const body = `json=${encodeURIComponent(JSON.stringify(form))}`
    return adminAPIService({
      url: `/discounts/${id}`,
      method: 'post',
      data: body,
    })
  },
  confirmPartialRefund(id) {
    return adminAPIService({
      url: `${route}/orders/refunds/${id}/partial`,
      method: 'post',
    })
  },
  confirmFullRefund(id) {
    return adminAPIService({
      url: `${route}/orders/refunds/${id}/full`,
      method: 'post',
    })
  },
  validatePartialRefund(id, status) {
    return adminAPIService({
      url: `${route}/orders/refunds/${id}/validate-partial`,
      method: 'post',
      data: `status=${status}`,
    })
  },
  validateFullRefund(id, status) {
    return adminAPIService({
      url: `${route}/orders/refunds/${id}/validate-full`,
      method: 'post',
      data: `status=${status}`,
    })
  }
}
